import { useCallback, useState } from 'react';
import { hasUTF8BOM } from 'components/DownloadButton/useCSVString';

export const useUTF8BOMWarning = (): [
  boolean,
  (file: File) => void,
  () => void,
] => {
  const [showUTF8Warning, setShowUTF8Warning] = useState(false);

  const checkUTF8BOM = useCallback((file: File) => {
    setShowUTF8Warning(false);
    hasUTF8BOM(file).then((hasBOM) => !hasBOM && setShowUTF8Warning(true));
  }, []);

  const resetUTF8Warning = useCallback(() => setShowUTF8Warning(false), []);

  return [showUTF8Warning, checkUTF8BOM, resetUTF8Warning];
};
